export const galleryImages = [
  {
    url: "https://assets.auxodev.dk/assets/0fa1183b-3f51-46de-aff6-df593e862933/8c9360eb-5d59-42b9-a696-2cb11141fa51.jpg",
    title: "Højtbelagt smørrebrød",
    description: "Klassisk dansk smørrebrød med friske råvarer"
  },
  {
    url: "https://assets.auxodev.dk/assets/0fa1183b-3f51-46de-aff6-df593e862933/b64b104c-6f24-4ab1-9688-7fb928c52b4e.jpg",
    title: "Lækre sandwich",
    description: "Friskbagte boller med fyld af højeste kvalitet"
  },
  {
    url: "https://assets.auxodev.dk/assets/0fa1183b-3f51-46de-aff6-df593e862933/f01bf544-c7fd-46a5-b46e-7aade72b2784.jpg",
    title: "Smørrebrødsplatter",
    description: "Anretninger til fester og arrangementer"
  },
  {
    url: "https://assets.auxodev.dk/assets/0fa1183b-3f51-46de-aff6-df593e862933/23fa2a6a-f483-405b-bd63-5414a9cb56c5.jpg",
    title: "Fiskefilet med remoulade",
    description: "Klassisk fiskefilet på hjemmelavet rugbrød"
  },
  {
    url: "https://assets.auxodev.dk/assets/0fa1183b-3f51-46de-aff6-df593e862933/1c856953-41f0-474a-9a12-12b972ea5000.jpg",
    title: "Hønsesalat med bacon",
    description: "Hjemmelavet hønsesalat med sprød bacon"
  },
  {
    url: "https://assets.auxodev.dk/assets/0fa1183b-3f51-46de-aff6-df593e862933/85c2c89a-00bc-4aa6-a723-ddfe1a3b4f01.jpg",
    title: "Smørrebrød til frokost",
    description: "Altid frisksmurt og klar til afhentning"
  },
  {
    url: "https://assets.auxodev.dk/assets/0fa1183b-3f51-46de-aff6-df593e862933/295f3ea1-abf0-422b-9f87-a341073d80fe.jpg",
    title: "Friske råvarer",
    description: "Vi udvælger kun de bedste råvarer hver dag"
  },
  {
    url: "https://assets.auxodev.dk/assets/0fa1183b-3f51-46de-aff6-df593e862933/898aa03e-7ed9-493b-80a1-3c235fae6c88.jpg",
    title: "Firmafrokost",
    description: "Frokostordninger tilpasset jeres virksomhed"
  },
  {
    url: "https://assets.auxodev.dk/assets/0fa1183b-3f51-46de-aff6-df593e862933/53240b71-1624-437a-8c9d-0f732bdcae67.jpg",
    title: "Luksussmørrebrød",
    description: "Det lille ekstra til de særlige lejligheder"
  }
];
